/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/warenkorb-entry.ts.
 */
import {Artikel} from './artikel';
import {Nachfolgeartikel} from './nachfolgeartikel';
import {WarenkorbEntryDtpZusatzdaten} from './warenkorb-entry-dtp-zusatzdaten';
import {ImportHinweisOption} from './import-hinweis';

/**
 * Zweck: Beschreibt class WarenkorbEntry und ihren Daten- oder Funktionsvertrag.
 */
export class WarenkorbEntry {
  id: number;
  artikel: Artikel|Nachfolgeartikel;
  menge: number;
  addedByHook: boolean;
  note: string[];
  print_note_lines: any[];
  positionsart = 'Standard';
  freimenge;
  aktionsrabattmenge;
  naturalrabattmenge;
  aktionsrabattprozent;
  basisverrechnungspreis: number;
  basisverrechnungspreisrabattprozent = 0;
  view_slug: string;
  readyToSend: boolean;
  hatImportHinweisZugestimmt: boolean;
  importHinweisOption: ImportHinweisOption;
  importHinweisEntscheidung: 'confirm' | 'reduce';
  dtpErstOderFolgeverschreibungErfassen: boolean;
  dtpErstOderFolgeverschreibung: string;
  dtpZusatzdaten: WarenkorbEntryDtpZusatzdaten[];
  nachliefern: boolean;

  dirty = false;
  valid = true; // WIRD PER WARENKORB ENTRY EDIT GESETZT

  defect: boolean;
  defectInfo: string;

  gui_disableDeleteButton = false;
  gui_targetMenge = undefined;
  gui_importHinweisAbgelehnt = false;
  gui_previousMenge: number;

/**
 * Beschreibt Methode getSumme und ihren Rückgabevertrag.
 */
  getSumme() {
    if (this.basisverrechnungspreis !== null &&
      (this.basisverrechnungspreis === 0 || this.basisverrechnungspreis > 0 || this.basisverrechnungspreis < 0)) {
      return this.basisverrechnungspreis * this.menge;
    } else {
      return this.artikel.Kundeneinkaufspreis * this.menge;
    }
  }
}
